var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame133(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 180,
    viewBox: "0 0 179 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M35.5 170C109.23 170 169 110.23 169 36.5C169 -37.23 109.23 -97 35.5 -97C-38.23 -97 -98 -37.23 -98 36.5C-98 110.23 -38.23 170 35.5 170Z",
    stroke: "url(#paint0_linear_64_6553)",
    strokeWidth: 20,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 97.8767C69.3975 97.8767 96.8768 70.3974 96.8768 36.4999C96.8768 2.6024 69.3975 -24.877 35.5 -24.877C1.60251 -24.877 -25.8768 2.6024 -25.8768 36.4999C-25.8768 70.3974 1.60251 97.8767 35.5 97.8767Z",
    stroke: "url(#paint1_linear_64_6553)",
    strokeWidth: 20,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_64_6553",
    x1: -113.346,
    y1: 36.4995,
    x2: 184.344,
    y2: 36.4995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD71D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_64_6553",
    x1: -41.2223,
    y1: 36.4994,
    x2: 112.221,
    y2: 36.4994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD71D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB200"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame133);
export default __webpack_public_path__ + "static/media/Frame 133.3070e462c66ce6fe3b0cb143c27a7528.svg";
export { ForwardRef as ReactComponent };